// `benefit_points_dashboard` gates the administrators' benefit points
// dashboard. Seed migration: amsm-backend
// hall/feature_flags/migrations/0012_seed_benefit_points_dashboard_flag.py —
// off for every tenant until an administrator turns it on. The backend
// endpoints answer 404 while it's off, on top of this frontend gate.
export const BENEFIT_POINTS_DASHBOARD_FLAG = 'benefit_points_dashboard'

export const BENEFIT_POINTS_DASHBOARD_PATH = '/benefit-points-dashboard'

// Mirrors amsm-backend's `BenefitPointActionType`
export const ACTION_TYPE_LABELS = {
  workout_print: 'Impressão de treino',
  workout_done: 'Treino concluído',
  physical_evaluation_print: 'Impressão de avaliação física',
  payment_before_due: 'Pagamento em dia',
  service_usage: 'Uso de serviços',
  space_rental: 'Aluguel de espaço',
  physical_access: 'Entrada pela catraca',
  invoice_download: 'Download de boleto',
}

export const actionTypeLabel = (actionType) =>
  ACTION_TYPE_LABELS[actionType] || actionType
